"use client";
import React, { useState } from "react";
import useWindowWidth from "@/hooks/useWindowWidth";
import RoomtypeItemBox from "./RoomtypeItemBox";
import SwiperBox from "./SwiperBox";
import SwiperClass from "swiper/types/swiper-class";

interface RoomItem {
  id: string | number;
  isReservationAvailability?: boolean;
  imageUrl?: string;
  name?: string;
  discountPrice?: number;
  roomRate?: number;
  description?: string;
  standardPeopleCount?: number;
  maximumPersonnelCount?: number;
  squareMeter?: number;
  bedSingleSizeCount?: number;
  bedQueenSizeCount?: number;
  bedKingSizeCount?: number;
  checkIn?: string;
  checkOut?: string;
  blockTitle?: string;
}

interface RoomPeriod {
  start: string | null;
  end: string | null;
}

interface RoomHeadcount {
  adult: number | string;
  kid: number;
  pet: number;
}

interface Props {
  title: string;
  roomList?: RoomItem[];
  stayCount: number;
  period: RoomPeriod;
  headcount: RoomHeadcount;
}

const RoomTypeList = ({
  title,
  roomList,
  stayCount,
  period,
  headcount,
}: Props) => {
  const width = useWindowWidth();
  const [swiperIndex, setSwiperIndex] = useState(0); // -> 페이지네이션용
  const [swiper, setSwiper] = useState<SwiperClass>(); // -> 슬라이드용

  // 슬라이드 이벤트핸들러
  const handlePrev = () => {
    swiper?.slidePrev();
  };

  const handleNext = () => {
    swiper?.slideNext();
  };

  const onSwiper = (data: SwiperClass) => {
    setSwiper(data);
  };

  const onSwiperIndex = (data: number) => {
    setSwiperIndex(data);
  };

  // Calculate slidesPerView based on screen width
  const getSlidesPerView = () => {
    if (width > 1600) return 2.5;
    if (width > 1300) return 2.2;
    if (width > 1000) return 1.8;
    if (width > 768) return 1.4;
    return 1;
  };

  return (
    <div className="pt-[115px] pb-[42px] mobile:pt-[0px]">
      <div className="text-[24px] font-[600] mb-[18px]">{title}</div>
      <div className="overflow-hidden">
        <SwiperBox
          freeMode={false}
          slidesPerView={getSlidesPerView()}
          spaceBetween={20}
          scrollbarHide={true}
          type="A"
          category="room"
          onSwiper={onSwiper}
          onSwiperIndex={onSwiperIndex}
          list={roomList?.map((item: RoomItem) => (
            <RoomtypeItemBox
              key={item.id}
              roomId={String(item.id)}
              room={item}
              stayCount={stayCount}
              period={period}
              headcount={headcount}
            />
          ))}
        />
      </div>
    </div>
  );
};

export default RoomTypeList;